import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { FileCategorySelect } from './file-category-select';
import { AvailableFileCategories } from './file-upload-types';

export const FILE_CATEGORY_SECTION_TEST_ID = 'file-category-section';

interface FileCategorySectionProps {
  availableFileDetails: AvailableFileCategories;
}

export const FileCategorySection = ({
  availableFileDetails,
}: FileCategorySectionProps): JSX.Element => (
  <HHStack
    direction="column"
    spacing={2}
    flex={1}
    minWidth={180}
    data-testid={FILE_CATEGORY_SECTION_TEST_ID}
  >
    <HHTypography hhVariant="variant-bypass" variant="h6">
      File Category
    </HHTypography>
    <HHTypography
      hhVariant="variant-bypass"
      variant="body2"
      color="text.secondary"
    >
      Select the type of file you want to upload.
    </HHTypography>
    <FileCategorySelect availableFileDetails={availableFileDetails} />
  </HHStack>
);
